







































































import { Component, Vue } from 'vue-property-decorator'
import TableForm from '@/components/common/TableForm.vue'
import SearchForm from '@/components/common/SearchForm.vue'
import MerchantDialog from './MerchantDialog.vue'
import StatusEffective from '@/components/common/StatusEffective.vue'

import $Api from '@api'
import { finalize } from 'rxjs/operators'
import { statusMap } from '@/utils/status-map'
import { Channel } from '@/api/model/channel'

@Component({
    components: {
        SearchForm,
        TableForm,
        StatusEffective,
        MerchantDialog
    }
})
export default class extends Vue {
    formEl: any
    searchForm = {
        current: 1,
        size: 10,
        channelId: null,
        status: null
    }
    statusMap = statusMap
    statusOptions = statusMap.createArray()
    channelOptions: Channel[] = []

    tableLoading = false
    tableData = []
    total = 0

    formProp = {}
    show = false
    disabled = false

    onSearchSubmit() {
        this.searchForm.current = 1
        this.getData()
    }

    getChannels() {
        $Api.channelService.queryChannelDropdown().subscribe(data => {
            this.channelOptions = data
        })
    }

    getData(pageQuery = {}) {
        // TODO： status 查询后台结果没有变化
        this.tableLoading = true
        $Api.channelService
            .merchantManageList(Object.assign(this.searchForm, pageQuery))
            .pipe(
                finalize(() => {
                    this.tableLoading = false
                })
            )
            .subscribe(data => {
                this.tableData = data.list
                this.total = data.total
            })
    }

    // 新建
    createChannel() {
        this.formProp = {}
        this.show = true
        this.disabled = false
    }

    // 编辑
    modify(row: any) {
        this.formProp = { ...row }
        this.show = true
        this.disabled = false
    }

    // 查看
    queryDeatil(row: any) {
        this.formProp = { ...row }
        this.show = true
        this.disabled = true
    }

    created() {
        this.getData()
        this.getChannels()
    }
}
